import axiosInstance from "src/api/axiosInstance";
import { getBrowserId } from "src/utils/browserId";
import { ReportFilter } from "src/helpers/Enums";

export async function login(email, password) {
  try {
    const response = await axiosInstance.post("/api/auth/login", {
      username: email,
      password: password,
    });
    if (response?.data?.data) {
      // Eski sistem için
      localStorage.setItem("token", response?.data?.data?.accessToken);

      // Yeni auth sistemi için
      const authData = {
        accessToken: response?.data?.data?.accessToken,
      };
      localStorage.setItem("kt-auth-react-v", JSON.stringify(authData));

      return response?.data?.data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Login error:", error);
    return false;
  }
}

export function forgotPassword(email) {
  const response = axiosInstance.post("/api/auth/forgot-password", {
    email: email,
  });
  return response;
}

export function getTags(request) {
  const params = new URLSearchParams();

  if (request.name) params.append("name", request.name);
  if (request.sort) params.append("sortBy", request.sort);
  if (request.pageNumber !== null && request.pageNumber !== undefined)
    params.append("pageNumber", request.pageNumber);
  if (request.pageSize !== null && request.pageSize !== undefined)
    params.append("pageSize", request.pageSize);

  const url = "/api/tags/search?" + params.toString();

  return axiosInstance.get(url);
}

export function createTag(name) {
  const response = axiosInstance.post("/api/tags/create", {
    name: name,
  });
  return response;
}

export function updateTag(tag) {
  const response = axiosInstance.put("/api/tags/update/" + tag?.id, {
    name: tag?.name,
    usedProducts: tag?.usedProducts,
  });
  return response;
}

export function deleteTags(ids) {
  return axiosInstance.delete("/api/tags/delete", {
    data: { ids },
  });
}

export function getStrategies(request) {
  const params = new URLSearchParams();

  if (request.name) params.append("name", request.name);
  if (request.sort) params.append("sortBy", request.sort);
  if (request.pageNumber !== null && request.pageNumber !== undefined)
    params.append("pageNumber", request.pageNumber);
  if (request.pageSize !== null && request.pageSize !== undefined)
    params.append("pageSize", request.pageSize);

  const url = "/api/strategies/search?" + params.toString();

  return axiosInstance.get(url);
}

export function createStrategy(name) {
  const response = axiosInstance.post("/api/strategies/create", {
    name: name,
  });
  return response;
}

export function updateStrategy(tag) {
  const response = axiosInstance.put("/api/strategies/update/" + tag?.id, {
    name: tag?.name,
  });
  return response;
}

export function deleteStrategy(ids) {
  return axiosInstance.delete("/api/strategies/delete", {
    data: { ids },
  });
}

export function createCampaign(request) {
  const response = axiosInstance.post("/api/campaign/create", request);
  return response;
}

export function updateCampaign(request) {
  const response = axiosInstance.post("/api/campaign/update", request);
  return response;
}

export function generateAI(request) {
  const response = axiosInstance.post("/api/ai/async/generate-ai", request);
  return response;
}

export function updateCampaignStatus(request) {
  const response = axiosInstance.post("/api/campaign/update/status", request);
  return response;
}

export function updateCampaignFavorite(request) {
  const response = axiosInstance.post("/api/campaign/update/favorite", request);
  return response;
}

export function getCampaigns(request) {
  const params = new URLSearchParams();

  if (request.name) params.append("name", request.name);
  if (request.sort) params.append("sortBy", request.sort);
  if (request.pageNumber !== null && request.pageNumber !== undefined)
    params.append("pageNumber", request.pageNumber);
  if (request.pageSize !== null && request.pageSize !== undefined)
    params.append("pageSize", request.pageSize);
  if (request.isFavorite !== null && request.isFavorite !== undefined)
    params.append("isFavorite", request.isFavorite);
  const url = "/api/campaign/search?" + params.toString();

  return axiosInstance.get(url);
}

export function deleteCampaign(id) {
  return axiosInstance.delete("/api/campaign/delete/" + id);
}

export function getDomains() {
  const response = axiosInstance.get("/api/domain/all");
  return response;
}

export function getPages() {
  const response = axiosInstance.get("/api/page/search?sortBy=AZ&pageNumber=0&pageSize=100000");
  return response;
}

export function getPage(id) {
  const response = axiosInstance.get("/api/page/" + id);
  return response;
}

export function getPartners() {
  const response = axiosInstance.post("/api/everflow/affiliatestable", {});
  return response;
}

export function createPage(pageData) {
  const response = axiosInstance.post("/api/page/create", pageData);
  return response;
}

export function createProductPage(pageData) {
  const response = axiosInstance.post("/api/product/card/create", pageData);
  return response;
}

export function updateProductPage(pageData) {
  const response = axiosInstance.post("/api/product/card/update", pageData);
  return response;
}

export function entryComplete(request) {
  const response = axiosInstance.post("/api/item/entry/complete", {
    costItemEntry: request,
  });
  return response;
}

export function getReportByMonth(request) {
  const params = new URLSearchParams();

  if (request.partitionDate) params.append("partitionDate", request.partitionDate);
  if (request.costItemType) params.append("costItemType", request.costItemType);

  const url = "/api/item/report/by/month?" + params.toString();

  return axiosInstance.get(url);
}

export function getProductsByReportId(request) {
  const params = new URLSearchParams();

  if (request.source) params.append("source", request.source);
  if (request.id) params.append("id", request.id);
  if (request.startTime) params.append("startTime", request.startTime);
  if (request.endTime) params.append("endTime", request.endTime);

  const url = "/api/report/get/detailV2?" + params.toString();

  return axiosInstance.get(url);
}

export function getPageInfoFromPath(url) {
  const response = axiosInstance.get("/api/ai/path/?url=" + url);
  return response;
}

export function getProductsListFromPath(url, page, limit, sortingType) {
  const params = new URLSearchParams();
  params.append("url", url);
  params.append("page", String(page));
  params.append("limit", String(limit));
  if (sortingType) params.append("sortingType", sortingType);
  const response = axiosInstance.get(
    "/api/ai/path/products/?" + params.toString().replace(/%2F/gi, "/"),
  );
  return response;
}

export function getCategories() {
  return axiosInstance.get("/api/categories");
}

const appendCategoryIdParam = (params, categoryId) => {
  if (categoryId == null) return;
  if (typeof categoryId === "object") {
    if (categoryId.timestamp != null) {
      params.append("categoryId.timestamp", String(categoryId.timestamp));
    }
    if (categoryId.date != null) {
      params.append("categoryId.date", String(categoryId.date));
    }
    return;
  }
  params.append("categoryId", String(categoryId));
};

export function getProductsByCategoryFromPath(url, categoryId, page, limit, sortingType) {
  const params = new URLSearchParams();
  params.append("url", url);
  appendCategoryIdParam(params, categoryId);
  params.append("page", String(page));
  params.append("limit", String(limit));
  if (sortingType) params.append("sortingType", sortingType);
  return axiosInstance.get(
    "/api/ai/path/products/by-category/?" + params.toString().replace(/%2F/gi, "/"),
  );
}

export function getDashboardData() {
  const response = axiosInstance.post("/api/dashboard/get-dashboard-data");
  return response;
}

export function getReportsData(request, config = {}) {
  const params = new URLSearchParams();

  if (request.source) params.append("source", request.source);
  if (request.type) params.append("type", request.type);
  if (request.time !== null && request.time !== undefined) params.append("time", request.time);
  if (request.name) params.append("name", request.name);
  if (request.startTime) params.append("startTime", request.startTime);
  if (request.endTime) params.append("endTime", request.endTime);
  const v4url = "/api/report/get/dateV4?" + params.toString();
  const v2url = "/api/report/get/dateV2?" + params.toString();
  if (request.range === ReportFilter.OTHER) return axiosInstance.get(v4url, config);
  return axiosInstance.get(v2url, config);
}
export function createEvent(data) {
  const response = axiosInstance.post("/api/events/create", data);
  return response;
}

/** Periodic flush of accumulated viewing time. */
export function recordProductDwell(payload) {
  return axiosInstance.post("/api/events/dwell", payload);
}

/**
 * Last flush as the page goes away. Uses fetch with keepalive rather than
 * navigator.sendBeacon because the request has to carry the browser_id header,
 * and sendBeacon cannot set headers.
 */
export function recordProductDwellOnUnload(payload) {
  try {
    const headers = { "Content-Type": "application/json" };
    const browserId = getBrowserId();
    if (browserId) headers["browser_id"] = browserId;
    return fetch(`${process.env.REACT_APP_BACKEND_URL}/api/events/dwell`, {
      method: "POST",
      keepalive: true,
      headers,
      body: JSON.stringify(payload),
    });
  } catch (e) {
    return Promise.resolve();
  }
}

/** Edits one AB variant's text, or an image variant's media URL. */
export function updateABValue(id, value) {
  return axiosInstance.post("/api/ab/update-ab-value", { id, value });
}

/** Retires one variant: it stops being shown and served, measurements are kept. */
export function deleteABValue(id) {
  return axiosInstance.post("/api/ab/delete-ab-value", { id });
}

/** Adds a hand-supplied image or video as a new variant of the product. */
export function uploadABMedia({ productId, key, file }) {
  const form = new FormData();
  form.append("productId", productId);
  if (key) form.append("key", key);
  form.append("file", file);
  return axiosInstance.post("/api/ab/upload-ab-media", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

/** Queues AI video generation for the product's current image iteration. */
export function addVideoToAb(productId) {
  return axiosInstance.post("/api/ab/add-video-to-ab", { productId });
}

export function getABWinnersAndLosers(request) {
  const params = new URLSearchParams();

  if (request?.productId) params.append("productId", request.productId);

  const url = "/api/ab/get-ab-winners-and-losers?" + params.toString();
  return axiosInstance.get(url);
}

export function getABConfiguration() {
  return axiosInstance.get("/api/ab/get-ab-configuration");
}

export function setABConfiguration(body) {
  return axiosInstance.post("/api/ab/set-ab-configuration", {
    minImpression: body.minImpression,
    textMetric: body.textMetric,
    winnerPercentage: body.winnerPercentage,
    imageMinCount: body.imageMinCount,
    imageMetric: body.imageMetric,
  });
}

export function getLatestAiSortSnapshot(campaignId) {
  return axiosInstance.get("/api/listecles/ai-sort-snapshot/latest", {
    params: { campaignId },
  });
}

export function getAiSortSnapshotById(snapshotId) {
  return axiosInstance.get(`/api/listecles/ai-sort-snapshot/${snapshotId}`);
}

export function getAiSortSnapshotHistory(campaignId) {
  return axiosInstance.get("/api/listecles/ai-sort-snapshot/history", {
    params: { campaignId },
  });
}

const trendsViewPathId = (id) => {
  if (id == null) return "";
  if (typeof id === "object") return id.id ?? id.$oid ?? id.timestamp ?? "";
  return id;
};

const appendDefinedParams = (params, entries) => {
  Object.entries(entries).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params.append(key, value);
    }
  });
};

export function getTrendsViews(request = {}, config = {}) {
  const params = new URLSearchParams();
  appendDefinedParams(params, {
    name: request.name,
    sortBy: request.sortBy,
    ascending: request.ascending,
    pageNumber: request.pageNumber,
    pageSize: request.pageSize,
  });
  const query = params.toString();
  return axiosInstance.get(`/api/trends/views${query ? `?${query}` : ""}`, config);
}

export function getTrendsView(id, config = {}) {
  return axiosInstance.get(`/api/trends/views/${trendsViewPathId(id)}`, config);
}

export function createTrendsView(body, config = {}) {
  return axiosInstance.post("/api/trends/views", body, config);
}

export function updateTrendsView(id, body, config = {}) {
  return axiosInstance.put(`/api/trends/views/${trendsViewPathId(id)}`, body, config);
}

export function deleteTrendsViews(ids, config = {}) {
  const payloadIds = (Array.isArray(ids) ? ids : [ids]).map((id) => trendsViewPathId(id) || id);
  return axiosInstance.delete("/api/trends/views", {
    ...config,
    data: { ids: payloadIds },
  });
}

export function runTrends(body, config = {}) {
  return axiosInstance.post("/api/trends/run", body, config);
}

export function runTrendsView(id, body, config = {}) {
  return axiosInstance.post(`/api/trends/views/${trendsViewPathId(id)}/run`, body ?? {}, config);
}

export function searchTrendsItems(request = {}, config = {}) {
  const params = new URLSearchParams();
  appendDefinedParams(params, {
    q: request.q,
    type: request.type,
    listicleId: trendsViewPathId(request.listicleId),
    from: request.from,
    to: request.to,
    pageNumber: request.pageNumber,
    pageSize: request.pageSize,
  });
  return axiosInstance.get(`/api/trends/items/search?${params.toString()}`, config);
}

export function getTrendChanges(config = {}) {
  return axiosInstance.get("/api/trends/changes", config);
}

export function getTrendsItemsByListicle(request = {}, config = {}) {
  const params = new URLSearchParams();
  appendDefinedParams(params, {
    q: request.q,
    pageNumber: request.pageNumber,
    pageSize: request.pageSize,
  });
  const query = params.toString();
  return axiosInstance.get(`/api/trends/items/by-listicle${query ? `?${query}` : ""}`, config);
}

export default {
  login,
  forgotPassword,
  entryComplete,
  getReportByMonth,
  getTags,
  createTag,
  deleteTags,
  updateTag,
  getStrategies,
  createStrategy,
  deleteStrategy,
  updateStrategy,
  getDomains,
  getCampaigns,
  createCampaign,
  getPages,
  getPartners,
  deleteCampaign,
  getPage,
  getPageInfoFromPath,
  updateCampaignStatus,
  updateCampaignFavorite,
  generateAI,
  getDashboardData,
  getReportsData,
  updateCampaign,
  getProductsByReportId,
  getProductsListFromPath,
  getCategories,
  getProductsByCategoryFromPath,
  getABWinnersAndLosers,
  updateABValue,
  deleteABValue,
  uploadABMedia,
  addVideoToAb,
  getABConfiguration,
  setABConfiguration,
  getLatestAiSortSnapshot,
  getAiSortSnapshotById,
  getAiSortSnapshotHistory,
  getTrendsViews,
  getTrendsView,
  createTrendsView,
  updateTrendsView,
  deleteTrendsViews,
  runTrends,
  runTrendsView,
  searchTrendsItems,
  getTrendChanges,
  getTrendsItemsByListicle,
};
